import { useVerifyToken } from "../../hooks/useVerifyToken";
import { Content, Container, IterableSection } from "./styles";
import { RDMItem } from "./components/RDMItem";
import { RdmModal } from "./components/RdmModal";
import { useRdm } from "./viewModel/useRdm";
import { RemoveRdmModal } from "./components/RemoveRdmModal";
import Menu from "../../components/general/Menu";
import Pagination from "../../components/general/Pagination";
import TopBar from "../../components/general/TopBar";
import SearchSection from "./components/SearchSection";
import ReactLoading from "react-loading";

export default function RDMPage({ location }) {
  const {
    data,
    actualRdm,
    loading,
    titleSearch,
    handleDebouncedSearchTitle,
    updateFilters,
    typeFilter,
    openFilterOptions,
    setOpenFilterOptions,
    handleOpenModal,
    totalPages,
    openModal,
    setOpenModal,
    form,
    filterOptions,
    selectNoneFilter,
    handleSubmit,
    openRemoveModal,
    onDelete,
    handleOpenRemove,
    handleCloseRemove,
    goToPanel,
  } = useRdm(location);

  useVerifyToken();

  return (
    <>
      <div style={{ display: "flex", height: "100%", width: "100%" }}>
        <Menu />
        <Container>
          <TopBar text="Rdms" />
          <Content>
            <SearchSection
              onClickButton={handleOpenModal}
              openFilterOptions={openFilterOptions}
              setOpenFilterOptions={setOpenFilterOptions}
              setTitleSearch={handleDebouncedSearchTitle}
              titleSearch={titleSearch}
              filterOptions={filterOptions}
              onSelectNoneOption={selectNoneFilter}
            />
            <IterableSection>
              {loading ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <ReactLoading type="bars" color="#118052" />
                </div>
              ) : data.length === 0 ? (
                <span style={{ textAlign: "center", fontFamily: "Sora" }}>
                  Não foram encontrados RDMs cadastrados
                </span>
              ) : (
                data.map((item, index) => (
                  <RDMItem
                    key={index}
                    rdm={item}
                    onRemove={handleOpenRemove}
                    onClick={() => goToPanel(item._id)}
                  />
                ))
              )}
            </IterableSection>
          </Content>
        </Container>
        <Pagination
          style={{
            position: "absolute",
            bottom: "2rem",
            left: "50%",
          }}
          actualPage={typeFilter.page}
          onPageChange={(activePage) => {
            updateFilters({
              ...typeFilter,
              page: activePage,
            });
          }}
          numberOfPages={totalPages}
        />
      </div>
      <RdmModal
        onSubmit={handleSubmit}
        form={form}
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
      />
      <RemoveRdmModal
        title={actualRdm?.title}
        isOpen={openRemoveModal}
        onClose={handleCloseRemove}
        onConfirm={onDelete}
      />
    </>
  );
}
